var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 11 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m5.5 0 1.235 3.8h3.996L7.498 6.15l1.235 3.8L5.5 7.6 2.267 9.95l1.235-3.8L.269 3.8h3.996L5.5 0Z"
})));
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNSAwTDYuNzM0ODMgMy44MDA0MUgxMC43MzA4TDcuNDk3OTkgNi4xNDkxOUw4LjczMjgyIDkuOTQ5NTlMNS41IDcuNjAwODFMMi4yNjcxOCA5Ljk0OTU5TDMuNTAyMDEgNi4xNDkxOUwwLjI2OTE4OSAzLjgwMDQxSDQuMjY1MTdMNS41IDBaIiBmaWxsPSJub25lIi8+Cjwvc3ZnPgo=";